import LoadingIcon from './../../assets/LoadingIcon'
import './Loading.scss'

const Loading = () => {
  const letters = 'Loading...'.split('')

  return (
    <div className="dFlex fdColumn aiCenter jcContentCenter mt-5 mb-5 width500">
      <button className="btn dFlex aiCenter gap-2 primaryText">
        <LoadingIcon />
      </button>

      <div className="loading-text mt-2 primaryText">
        {letters.map((char, i) => (
          <span key={i} style={{ '--d': i }}>
            {char}
          </span>
        ))}
      </div>
    </div>
  )
}

export default Loading
